import { useContext, useEffect, useState } from "react";
import { MissionContext } from "../contexts/MissionTasksContext";
import { useUpdateMissionDataMutation } from "modules/pvs_activities/redux/service/missions";
import { displayNotification } from "helpers";
import Button from "components/common/Button";
import Column from "components/common/Column";
import Row from "components/common/Row";
import { Card } from "react-bootstrap";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";

const ReportShowButton = () => {
    const missionContext = useContext(MissionContext);
    useEffect(() => {
        setChecked(missionContext.showReport);
    }, [missionContext.showReport]);

    const [updateMissionData, { isLoading: isUpdating }] = useUpdateMissionDataMutation();
    const [checked, setChecked] = useState(missionContext.showReport || false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleSave = () => {
        try {
            updateMissionData({
                missionId: missionContext.missionData.id,
                data: { show_report: checked }
            }).then((response) => {
                if (response.error) {
                    displayNotification("error", response.error);
                    missionContext.taskTrigger();
                } else {
                    displayNotification("success", "Show Report status updated successfully!");
                }
            });
        } catch (e) {
            console.log(e);
            displayNotification("error", "Failed to update Show Report status");
        }
    };

    return (
        <>
            <Card className={`bg-light-2 p-5 rounded-0 h-100`}>
                <h2>Does this mission have a Report Workflow?</h2>
                {!missionContext.is_archived && (<Row className={"mb-3"}>
                    <Column col={6}>
                        <FormGroup>
                            <FormControlLabel control={
                                <Switch
                                    checked={checked}
                                    onChange={handleChange}
                                />
                            } label={checked ? 'Disable Report Workflow' : 'Enable Report Workflow'} />
                        </FormGroup>
                    </Column>
                </Row>)}
                {!missionContext.is_archived && (<div className="bg-transparent border-0 text-left">
                    <Button className="btn btn-outline rounded-5 p-2" onClick={handleSave}>
                        Save
                    </Button>
                </div>)}
            </Card>
        </>
    );
}
export default ReportShowButton;